module.exports = __webpack_public_path__ + "img/rouler_positions_back.55fdea02.png";